// extracted by mini-css-extract-plugin
module.exports = {"useCaseNew":"style_useCaseNew__Xrnbt"};